module.exports = __webpack_public_path__ + "img/heart2heart-poster1.74d031c9.jpg";